import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IZBEmpowerCDFLoans = ({ question, answer }) => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings_Banner.png";
    const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}

                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}

            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Empowering Communities with CDF Loans</h1>

                    <p className="pb-3">Indo Zambia Bank proudly presented Constituency Development Fund (CDF) loans to beneficiaries in Milenge Constituency, helping local entrepreneurs and communities grow, create opportunities, and drive sustainable development. Together, we are building stronger communities and a brighter future for Zambia.</p>

                    <p><b><em>Pictured below, from left to right:</em></b></p>

                    <ol type="1">
                        <li style={{paddingLeft: '12px', paddingTop: '6px'}}><b>1.</b> Council Secretary for Milenge, <b>Luisha Inambwae</b></li>
                        <li style={{paddingLeft: '12px', paddingTop: '2px'}}><b>2.</b> Council Vice Chairperson, <b>Charles Mfula</b></li>
                        <li style={{paddingLeft: '12px', paddingTop: '2px'}}><b>3.</b> Indo Zambia Bank Senior Branch Manager, <b>Mildred Bwalya</b></li>
                        <li style={{paddingLeft: '12px', paddingTop: '2px'}}><b>4.</b> Hon. Eng. <b>Nason Musonda</b>, Provincial Minister, Luapula Province</li>
                        <li style={{paddingLeft: '12px', paddingTop: '2px'}}><b>5.</b> District Commissioner for Milenge, <b>Mr. Kayula Mulenga</b></li>
                    </ol>

                    <h2 className="pt-4 pb-4">Gallery</h2>
                   
                    <div className="test news-slider-list-slider row align-items-center">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/empowering-communities-with-cdf-loans-thumb.png" alt="" />
                            </div>
                        </Slider>
                    </div>
                </div>

            </section>

            <CustomerCare />
            <OurStores />

        </>
    );
};

export default IZBEmpowerCDFLoans;